import React from 'react';
import { Modal, Input, Form } from 'antd';

interface StoryConceptEditorModalProps {
  open: boolean;
  onCancel: () => void;
  onSave: (concept: string) => void;
  initialValue?: string;
}

const { TextArea } = Input;

const StoryConceptEditorModal: React.FC<StoryConceptEditorModalProps> = ({
  open,
  onCancel,
  onSave,
  initialValue,
}) => {
  const [form] = Form.useForm();

  React.useEffect(() => {
    if (open) {
      form.setFieldsValue({ storyConcept: initialValue });
    }
  }, [open, initialValue, form]);

  const handleSave = () => {
    form.validateFields().then((values) => {
      onSave(values.storyConcept);
    });
  };

  return (
    <Modal
      title="Edit Story Concept"
      open={open}
      onCancel={onCancel}
      onOk={handleSave}
      width={1000}
      style={{ top: 20 }}
      okText="Save Concept"
      destroyOnClose
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="storyConcept"
          label="Story Concept (Format, Setting, Characters, Tone, Skeleton...)"
          rules={[{ required: true, message: 'Please enter story concept!' }]}
        >
          <TextArea
            rows={25}
            placeholder="Describe your story in detail. Include character definitions, narrative style, and the skeleton for chapters..."
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default StoryConceptEditorModal;
